import { useEffect, RefObject } from 'react';

/**
 * Hook that triggers a callback when a click occurs outside the referenced element.
 * Useful for closing dropdowns, modals, or popovers when clicking outside.
 *
 * @param ref - React ref object pointing to the element to monitor
 * @param onClickOutside - Callback to execute when clicking outside the ref element
 */
const useClickOutsideRef = (
  ref: RefObject<HTMLElement | null>,
  onClickOutside: () => void
): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    window.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    }
  }, [ref, onClickOutside]);
}

export default useClickOutsideRef;
